// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1T8Oj","comment":"styles_comment__1pGG_"};